// extracted by mini-css-extract-plugin
export var label = "_iq-2";
export var slideContainer = "_iq-0";
export var slider = "_iq-1";